<template>
  <div>
    <Header />
    <Stepper />
    <div class="delivery section">
      <form @submit.prevent="submit">
        <div class="grid">
          <div class="grid-item product">
            <div class="img-product">
              <img :src="img" alt=""/>
            </div>
            <div class="caption"><span>{{prdName}}</span></div>
          </div>
          <div class="grid-item address">
            <ul>
              <li>
                <span>수령인</span>
                <strong>{{receive.name}}</strong>
              </li>
              <li>
                <span>배송지</span>
                <strong>{{receive.address1}}<br/>{{receive.address2}}</strong>
              </li>
              <li>
                <span>연락처</span>
                <strong>{{receive.phone1}}-{{receive.phone2}}-{{receive.phone3}}</strong>
              </li>
            </ul>
          </div>
          <div class="grid-item privacy">
            <dl>
              <dt>
                <input type="checkbox" class="checkbox-default" id="checkbox-sample" name="privacy" v-model="privacy" v-validate="{required: true}" data-vv-validate-on="change">
                <label for="checkbox-sample" v-bind:class="{ 'on': !privacy}">
                  <span>개인정보처리 및 제3자 정보 제공에 동의합니다</span>
                </label>
              </dt>
              <dd v-show="!privacy">
                구매하신 상품 배송 및 주문처리를 위해 개인정보를 제공받는 판매자, 택배사, 배송조회업체에게 배송정보를 제공하는데 동의합니다.
              </dd>
            </dl>
          </div>
          <div class="grid-item notice">
            <dl>
              <dt>유의사항 </dt>
              <dd>배송상품의 경우 배송신청완료 이후에 상품의 재고 상황에 따라 배송이 불가할 수 있습니다.</dd>
              <dd>배송상품의 배송지연/교환/환불에 관한 사항은 해당 상품의 판매처로 문의해 주시기 바랍니다. </dd>
              <dd>배송주소변경은 구매하신 판매처의 고객센터로 문의해 주시기 바랍니다.</dd>
            </dl>
          </div>
          <div class="buttn-area">
            <button type="button" class="button-full gray" v-if="errors.any() || privacy == false">배송신청</button>
            <button type="submit" class="button-full blue" v-if="!errors.any() && privacy == true">배송신청</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
import Stepper from '@/components/Stepper';
import axios from 'axios';

export default {
  name: "DeliverRequest",
  components: {
    Header,
    Stepper
  },
  data(){
    return {
      pin: this.$route.params.pin,
      img: this.$route.params.img,
      prdName: this.$route.params.prdNm,
      product: {},
      receive: {},
      privacy : false
    }
  },
  created(){
    // console.log(this.$route.params)
    this.product = JSON.parse(localStorage.product);
    this.receive = JSON.parse(localStorage.receive);
    console.log(this.$route.params)
  },
  methods: {
    submit(){
      if(confirm('배송신청을 하시겠습니까?')){
        axios.post(`${process.env.ENDPOINT}/deliver/request/register`, {
        pin: this.pin,
        rcpr_name: this.receive.name,
        rcpr_hp_tel: this.receive.phone1 + this.receive.phone2 + this.receive.phone3,
        rcpr_hp_auth_yn: 'Y',
        dlpc_post: this.receive.zonecode,
        dlpc_basic_addr: this.receive.address1,
        dlpc_det_addr: this.receive.address2,
        dlvy_req_matter_se_code: this.receive.requested,
        dlvy_req_matter_cntn: this.receive.requestDetail,
        privacy_use_agree_yn: (this.privacy == true) ? 'Y' : 'N'
      })
      .then(response => {
        console.log('response',response)
        if(response.status==200){
          let data = response.data;
          if(data.return_cd === '0000'){
            localStorage.removeItem('cert');
            localStorage.removeItem('receive');
            localStorage.removeItem('product');
            this.$router.push({ name: 'deliver-success',params: { pin: this.pin }});
          }
          else{
            console.log('cd error :', data.return_cd);
            alert('배송신청이 불가능한 상품권 입니다.\n사유 : '+data.return_msg)
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
      }
    }
  }
};
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';
.notice {
  margin-top: 0px !important;
}
.privacy {
  dl {
    dt {
      label {
        background: url(../assets/images/icon_privacy_toggle_bottom.png) no-repeat center right;
      }
      label.on {
        background: url(../assets/images/icon_privacy_toggle_top.png) no-repeat center right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DeliverRequest.vue